import { DbLoadNormalizedCargo } from "../../../data/usecases/load-normalized-cargos";
import { LoadNormalizedCargos } from "../../../domain/usecases/load-normalized-cargos";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl, makeAxiosHttpClient } from "../http";

export const makeDbLoadNormalizedCargos = (): LoadNormalizedCargos =>
  new DbLoadNormalizedCargo(
    makeApiUrl("/cargo"),
    makeAuthorizeHttpClientDecorator()
  );
